import React from 'react';
import clsx from 'clsx';

const sizes = { sm: 'w-8 h-8 text-xs', md: 'w-10 h-10 text-sm', lg: 'w-14 h-14 text-lg' };

const gradients = [
  'from-wa-500 to-wa-accent-indigo',
  'from-wa-accent-purple to-wa-accent-pink',
  'from-wa-accent-orange to-wa-accent-pink',
  'from-wa-accent-green to-wa-accent-teal',
  'from-wa-accent-teal to-wa-500',
  'from-wa-accent-indigo to-wa-accent-purple',
  'from-wa-accent-pink to-wa-accent-red',
];

function getGradient(name: string) {
  let hash = 0;
  // eslint-disable-next-line no-bitwise
  for (let i = 0; i < name.length; i += 1) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return gradients[Math.abs(hash) % gradients.length];
}

function getInitials(name: string) {
  return name
    .split(' ')
    .map(w => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export default function Avatar({
  name,
  src,
  size = 'md',
  online,
}: {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  online?: boolean;
}) {
  return (
    <div className="relative inline-flex">
      {src ? (
        <img
          src={src}
          alt={name}
          className={clsx('rounded-full object-cover ring-2 ring-white/80', sizes[size])}
        />
      ) : (
        <div
          className={clsx(
            'flex items-center justify-center rounded-full bg-gradient-to-br font-semibold text-white shadow-wa-apple',
            sizes[size],
            getGradient(name),
          )}
        >
          {getInitials(name)}
        </div>
      )}
      {online !== undefined && (
        <span
          className={clsx(
            'absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white ring-1 ring-white/50',
            online ? 'bg-wa-accent-green' : 'bg-gray-400',
          )}
        />
      )}
    </div>
  );
}
